import { get, isEmpty, isNil } from "lodash";
import { NODE_TYPES } from "utils/constants";
import { shownTab, STEP_KINDS, STEP_TABS, stepKind } from "./step-tabs";

export const MESSAGE_ROLES = { USER: "user", ASSISTANT: "assistant" };

export const MESSAGE_STATUSES = {
  PENDING: "pending",
  DONE: "done",
  FAILED: "failed",
};

export const PROPOSAL_STATUSES = {
  PENDING: "pending",
  APPLIED: "applied",
  REFUSED: "refused",
};

export const CHANGE_KINDS = {
  UPDATE_STEP: "update_step",
  ADD_STEP: "add_step",
  REMOVE_STEP: "remove_step",
  SET_RULES: "set_rules",
  SET_ANSWER_CHECKS: "set_answer_checks",
  REVISE_SCREEN: "revise_screen",
  ADD_STATE: "add_state",
  REMOVE_STATE: "remove_state",
  SET_STATE_CONDITIONS: "set_state_conditions",
  LINK_FIELD: "link_field",
  CREATE_FIELD: "create_field",
  EDIT_SCREEN_CODE: "edit_screen_code",
};

export const CHAT_MODES = { CODE: "code", ADMIN: "admin" };

export const CODE_TARGETS = { HTML: "html", CSS: "css" };

const SCREEN_CHANGES = [
  CHANGE_KINDS.REVISE_SCREEN,
  CHANGE_KINDS.ADD_STATE,
  CHANGE_KINDS.EDIT_SCREEN_CODE,
];

const TAB_BY_CHANGE = {
  [CHANGE_KINDS.UPDATE_STEP]: STEP_TABS.SETTINGS,
  [CHANGE_KINDS.ADD_STEP]: STEP_TABS.MAIN,
  [CHANGE_KINDS.REMOVE_STEP]: STEP_TABS.SETTINGS,
  [CHANGE_KINDS.SET_RULES]: STEP_TABS.NEXT,
  [CHANGE_KINDS.SET_ANSWER_CHECKS]: STEP_TABS.FIELDS,
  [CHANGE_KINDS.REVISE_SCREEN]: STEP_TABS.MAIN,
  [CHANGE_KINDS.ADD_STATE]: STEP_TABS.MAIN,
  [CHANGE_KINDS.REMOVE_STATE]: STEP_TABS.MAIN,
  [CHANGE_KINDS.SET_STATE_CONDITIONS]: STEP_TABS.MAIN,
  [CHANGE_KINDS.LINK_FIELD]: STEP_TABS.FIELDS,
  [CHANGE_KINDS.CREATE_FIELD]: STEP_TABS.FIELDS,
  [CHANGE_KINDS.EDIT_SCREEN_CODE]: STEP_TABS.MAIN,
};

export const proposalChanges = (message) =>
  (get(message, "proposal.changes") || []).filter(
    (change) => !isNil(change) && !isEmpty(change.kind),
  );

export const isScreenChange = (change) =>
  SCREEN_CHANGES.includes(change.kind) && !isEmpty(change.after);

const nodeTypeOf = (node) => get(node, "data.nodeType") || NODE_TYPES.STATUS;

const wantedTab = (change, node) => {
  const kind = stepKind(nodeTypeOf(node));
  if (
    change.kind === CHANGE_KINDS.UPDATE_STEP &&
    !isNil(get(change, "data.config")) &&
    kind !== STEP_KINDS.SCREEN
  )
    return STEP_TABS.MAIN;
  if (
    change.kind === CHANGE_KINDS.SET_ANSWER_CHECKS &&
    kind !== STEP_KINDS.SCREEN
  )
    return STEP_TABS.MAIN;
  return TAB_BY_CHANGE[change.kind] || STEP_TABS.MAIN;
};

export const changeTarget = (change, nodes = []) => {
  const node = nodes.find((item) => item.id === change.stepId);
  if (isNil(node)) return null;
  const stateId =
    change.kind === CHANGE_KINDS.ADD_STATE ? null : change.stateId || null;
  const states = get(node, "data.screenStates") || [];
  const state = states.find((item) => item.id === stateId) || null;
  return {
    node,
    stepId: node.id,
    stateId: isNil(state) ? null : state.id,
    state,
    tab: shownTab(nodeTypeOf(node), wantedTab(change, node)),
  };
};

export const stateCount = (nodes = []) =>
  nodes.reduce(
    (total, node) => total + (get(node, "data.screenStates") || []).length,
    0,
  );

export const codeEditsOf = (change) =>
  change.kind === CHANGE_KINDS.EDIT_SCREEN_CODE
    ? (get(change, "edits") || []).filter(
        (item) => !isNil(item) && !isEmpty(item.target),
      )
    : [];

export const errorText = (code, labels) =>
  get(labels, code) || get(labels, "DEFAULT");
